/// <reference types="./publishedGetTotalCount.d.ts" />
import { ok, } from '@dossierhq/core';
import { authResolveAuthorizationKeys } from '../Auth.js';
export async function publishedGetTotalCount(schema, authorizationAdapter, databaseAdapter, context, query) {
    const authKeysResult = await authResolveAuthorizationKeys(authorizationAdapter, context, query?.authKeys);
    if (authKeysResult.isError())
        return authKeysResult;
    const authKeys = authKeysResult.value;
    if (authKeys.length === 0) {
        // User requested with authKeys, but they resolved to nothing, so we won't match any entity
        return ok(0);
    }
    return await databaseAdapter.publishedEntitySearchTotalCount(schema, context, query, authKeys);
}
//# sourceMappingURL=publishedGetTotalCount.js.map